import { render, staticRenderFns } from "./DeliveryDrawerInitialStep.vue?vue&type=template&id=19dc3a36"
import script from "./DeliveryDrawerInitialStep.vue?vue&type=script&lang=js"
export * from "./DeliveryDrawerInitialStep.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports